import { ListItem, ListItemButton, ListItemText } from '@mui/material'

interface Props {
    linkTo: string;
    linkTxt: string;
}

const MenuLinkMobile = (props: Props) => {
    return (
        <ListItem disablePadding>
            <ListItemButton sx={{ textAlign: 'center' }} href={props.linkTo}>
                <ListItemText primary={props.linkTxt} />
            </ListItemButton>
        </ListItem>
    )
}

export default MenuLinkMobile